// Shared scroll+highlight helper for validation mixins (numeric, filter, required-when-enabled).
// Expects `instance` to be a Vue component instance that may optionally define
// `jsonFieldToggleMap` and/or `fieldPrefixSectionMap` to auto-expand a collapsed
// section before scrolling to a `data-field="<key>"` row.
export function scrollAndHighlightField(instance, key) {
  if (!key) return

  let toggleKey = null
  if (instance.jsonFieldToggleMap && instance.jsonFieldToggleMap[key]) {
    toggleKey = instance.jsonFieldToggleMap[key]
  }
  if (!toggleKey && instance.fieldPrefixSectionMap) {
    for (const [prefix, sectionKey] of instance.fieldPrefixSectionMap) {
      if (key.startsWith(prefix)) { toggleKey = sectionKey; break }
    }
  }

  const sectionWasClosed = toggleKey && instance.toggle && !instance.toggle[toggleKey]
  if (toggleKey && instance.toggle !== undefined) instance.$set(instance.toggle, toggleKey, true)
  const delay = sectionWasClosed ? 420 : 0

  instance.$nextTick(() => setTimeout(() => {
    const row = instance.$el.querySelector(`[data-field="${key}"]`)
    const scrollTarget = row || instance.$el
    if (typeof scrollTarget.scrollIntoView === 'function') {
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }
    // Always highlight the whole field (the row's cells, or the element
    // itself for non-row targets like section headers) rather than just the
    // input control, so the highlight looks consistent field-to-field.
    const highlightEls = (row && row.tagName === 'TR')
      ? Array.from(row.querySelectorAll('td, th'))
      : [scrollTarget]

    const isMidnight = document.documentElement.getAttribute('data-fi-theme') === 'midnight'
    const highlightColor = isMidnight ? '#5c1a1a' : '#fff3cd'
    const outlineColor = isMidnight ? '#e05555' : '#ffc107'

    highlightEls.forEach(el => {
      el.style.transition = 'none'
      el.style.backgroundColor = highlightColor
      el.style.outline = `2px solid ${outlineColor}`
    })
    setTimeout(() => {
      highlightEls.forEach(el => {
        el.style.transition = 'background-color 1.5s ease-out, outline-color 1.5s ease-out'
        el.style.backgroundColor = ''
        el.style.outlineColor = 'transparent'
      })
      setTimeout(() => highlightEls.forEach(el => { el.style.transition = ''; el.style.outline = '' }), 1600)
    }, 800)
  }, delay))
}
